import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";

import { TfInputFieldsModule } from "@app/modules/tf-input-fields";
import { TfButtonModule } from "@app/modules/tf-buttons";

import { TfDropdownsModule } from "@app/modules/tf-dropdowns";
import { TfTypeaheadModule } from "@app/modules/tf-typeahead";

import { TfSearchHeaderComponent } from "./components/search-header/search-header.component";
import { TfSearchHeaderMobileSpaceDirective } from "./directives/search-header-mobile-space.directive";
import { TranslateModule } from "@ngx-translate/core";
@NgModule({
    declarations: [TfSearchHeaderComponent, TfSearchHeaderMobileSpaceDirective],
    imports: [
        CommonModule,
        FormsModule,
        NgbTypeaheadModule,
        TfButtonModule,
        TfInputFieldsModule,
        TfDropdownsModule,
        TranslateModule,
    ],
    exports: [TfSearchHeaderComponent, TfTypeaheadModule],
})
export class TfSearchHeaderModule {}
